<template>
  <div class="root d-inline-block">
    <!-- <button class="btn btn-success btn-block" @click="btnClicked">{{text}}</button> -->
    <toggle-button v-if="" @change="btnClicked($event)" :value="!isActive" color="#82C7EB" :width="100" :height="25"
                   :sync="true"
                   :labels="{unchecked: 'قابل فروش', checked: 'قابل فروش'}"/>
  </div>
</template>

<script>
  import EventBus from "../_framework/bus.js";
  import ToggleButton from "vue-js-toggle-button/src/Button";

  export default {
    name: "sellable-button",
    components: {
      ToggleButton
    },
    props: ["header", "params", "th"],
    data() {
      return {
        isActive: true,
        text: "قابل فروش"
      };
    },
    methods: {
      btnClicked(e) {
        // console.log(e);
        if (e.value === true) {
          this.$emit("onFetchList", {sellable: true});

        } else {
          this.$emit("onFetchList", {sellable: false});
        }
        this.isActive = !this.isActive;
        this.text = this.isActive ? "قابل فروش" : "تمام کالاها";
        // this.params.onClick();
      }
    }
  };
</script>

<style scoped>
  .vue-js-switch {
    font-size: 12px;
  }
</style>
